import { render, staticRenderFns } from "./GamePanel.vue?vue&type=template&id=19df8c36&scoped=true&"
import script from "./GamePanel.vue?vue&type=script&lang=js&"
export * from "./GamePanel.vue?vue&type=script&lang=js&"
import style0 from "./GamePanel.vue?vue&type=style&index=0&id=19df8c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df8c36",
  null
  
)

export default component.exports